import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.map";
import XLSX from 'xlsx';

function _file(file, callback) {
  var make_cols = function make_cols(refstr) {
    Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map(function (x, i) {
      return {
        name: XLSX.utils.encode_col(i),
        key: i
      };
    });
  };

  var reader = new FileReader();

  reader.onload = function (e) {
    var bstr = e.target.result;
    var wb = XLSX.read(bstr, {
      type: 'binary'
    });
    var wsname = wb.SheetNames[0];
    var ws = wb.Sheets[wsname];
    var data = XLSX.utils.sheet_to_json(ws, {
      header: 1
    });
    callback(data, make_cols(ws['!ref']));
  };

  reader.readAsBinaryString(file);
}

export function importExcel(callback) {
  var inputObj = document.createElement('input');
  inputObj.setAttribute('id', 'file');
  inputObj.setAttribute('type', 'file');
  inputObj.setAttribute('name', 'file');
  inputObj.setAttribute('style', 'visibility:hidden');
  inputObj.setAttribute('accept', '.xlsx,.xls');
  inputObj.addEventListener('change', function (evt) {
    var files = evt.target.files;

    if (files && files[0]) {
      _file(files[0], function (data, dataRef) {
        callback(data, dataRef);
      });
    }
  });
  document.body.appendChild(inputObj);
  inputObj.click();
}